//import { useEffect } from 'react';
import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import socketIOClient from "socket.io-client";
import Tools from './Tools';

const SocketActions = (props) => {

    const history = useHistory();

    useEffect(() => {

        let sessionData=JSON.parse(sessionStorage.getItem('sessionData'));
        if(sessionData){
            let extension=(sessionData?sessionData.extension:'NONE');

            //connect to socket if user refresh
            const socket=Tools.connectClientToSocket(socketIOClient, extension, sessionData.name, sessionData.profile_code, sessionData.hostId, 'socketActions');

            //backup socket on memory
            Tools.currentSocketConnection=socket;

            socket.on("FromAPI", data => {
                history.push("/"+ data.campaignId +"/"+ data.clientToLoad +"/"+ data.phone); 
            });
            
            socket.on("searchClientByInboundQueueAndPhone", data => {
                history.push("/clients/"+ data.inboundQueue +"/"+ data.phone); 
            });
            
            socket.on("ClaroVentasSearch", data => {
                history.push("/clientsClaroVentas/" + data.phone); 
            });

            socket.on("JunglabetSearch", data => {
                history.push("/clientsJunglabet/" + data.phone); 
            });

            socket.on("ClaroDicomSearch", data => {
                history.push("/clientsClaroDicom/" + data.phone); 
            });


            socket.on("disconnect", (reason, details) => {
                if (reason === 'transport close') {
                    alert('Al parecer has perdido la conexión con el servidor. Para reconectar y actualizar la información más reciente, te recomendamos que refresques la pantalla. Por favor, haz clic en el botón de actualización del navegador (generalmente un círculo con una flecha en la esquina superior) o presiona la tecla F5 en tu teclado.');
                }
            });


        } else {
            //alert('No hay datos de sesión disponibles. Por favor, inicia sesión nuevamente.');
            history.push("/login");
        }


    }, []);



    return (
        null
    );

}

export default SocketActions;